import { components } from "@certn/legacy-api/generated-schemas/people";

import { ValidationRuleType } from "./types";

export function requireEmploymentAddressRule(
  rule: components["schemas"]["RequireEmploymentAddressRule"]
): ValidationRuleType {
  return {
    rule,
    isValid: (
      employments: components["schemas"]["EmploymentCheckFieldValue"][]
    ) => employments.length > 0 && employments.every(({ address }) => address),
  };
}
